<p-panel
  styleClass="panel-shadow"
  *ngIf="
    (organisationTypeId == 1 || organisationTypeId == 2) &&
    inspectionContacts &&
    inspectionContacts.showInspectionContact
  "
  [style]="{ 'margin-top': '1em' }"
>
  <p-header>
    <div class="panel-header">Inspection Contacts</div>
  </p-header>

  <div [class.ghost]="loading">
    <div class="grid-label-value">
      <div class="">Contact:</div>
      <div class="value ghost-fill">{{ inspectionContacts.inspectionContactFullName }}</div>
    </div>
    <div
      class="grid-label-value"
      style="padding-top: 10px; margin-top: 10px; border-top: 1px solid #dfdfdf"
    >
      <div class="">Email:</div>
      <div class="value ghost-fill">{{ inspectionContacts.inspectionContactEmail }}</div>
    </div>
  </div>
</p-panel>
